module.exports = __webpack_public_path__ + "static/media/lateral-nonflexion-up-1.d08099c9.png";